import QuestionSection from './QuestionSection.view';

export default QuestionSection;
